import api from '.';

export const cadastrar = async (dados) => {
    const response = await api.post('/movimentoPedidoPadrao', dados);
    return response.data;
};

export const editar = async (uuid, dados) => {
    const response = await api.put(`/movimentoPedidoPadrao/${uuid}`, dados);
    return response.data;
};

export const remover = async (uuid) => {
    const response = await api.delete(`/movimentoPedidoPadrao/${uuid}`);
    return response.data;
};

export const listarPorParceiro = async ({ parceiroId, empresaId }) => {
    const response = await api.get(`/movimentoPedidoPadrao/parceiro/${parceiroId}`, {
        params: { empresaId },
    });

    return response.data;
};

export const obterPorUuid = async (uuid) => {
    const response = await api.get(`/movimentoPedidoPadrao/${uuid}`);
    return response.data;
};
